import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-arbetsorder-warning-pill",
    templateUrl: "./arbetsorder-warning-pill.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./arbetsorder-warning-pill.component.scss"]
})
export class ArbetsorderWarningPillComponent {
}
